import { Demonstration } from '~/utils/EmbeddingFeed/Demonstration';
import { EmbeddingFeed } from '~/utils/EmbeddingFeed/EmbeddingFeed';
import { constants } from '~/utils/EmbeddingFeed/UniversalEmbedding/constants';
import { parseUrlHash } from '~/utils/parseUrlHash';

const processEmbedding = new EmbeddingFeed();
const demonstration = new Demonstration();

/**
 * Проверяет адресную строку на предмет наличия команды активации процесса встраивания
 * и парсит параметры процесса в глобальную переменную
 */
const checkHash = (): boolean => {
  const hash = parseUrlHash();
  if (
    hash?.type &&
    hash?.type === constants.INIT_EMBEDDING_FEED_STRING_NAME_PROCESS &&
    hash?.platform &&
    hash?.uuid
  ) {
    window.clickstreamAnalyticUtilities.EmbeddingFeed = {
      platform: hash.platform as Platform,
      feedId: hash?.feedId || '0',
      uuid: hash.uuid,
      method: 'alternative',
      configuration: null,
    };
    processEmbedding.demonstration.reqRec = (hash?.reqRec as RequestRecommendationsFlag || 'off');

    return true;
  }

  return false;
};

/**
 * Инициализирует функции встраивания ленты рекомендаций
 */
export const initEmbeddingFeed = () => {
  window.clickstreamAnalyticUtilities = {
    EmbeddingFeed: {
      eventSource: null,
      platform: 'desktop',
      feedId: '0',
      uuid: '',
      method: 'standard',
      configuration: null,
    },
  };
  window.addEventListener('message', (event: any) => {
    switch (event.data.type) {
      case 'testSystemEmbedding': {
        event.source.postMessage(
          {
            type: 'answerTestSystemEmbedding',
            status: 'success',
          },
          '*'
        );
        break;
      }
      case constants.INIT_EMBEDDING_FEED_STRING_NAME_PROCESS: {
        window.clickstreamAnalyticUtilities.EmbeddingFeed = {
          eventSource: event.source,
          platform: event.data.platform,
          feedId: event.data?.feedId || '0',
          uuid: event.data.uuid,
          method: 'standard',
          configuration: event.data.configuration,
        };
        processEmbedding.demonstration.reqRec = event.data?.reqRec || 'off';
        processEmbedding.startEmbeddingFeed();
        break;
      }
      case 'showFeedParameters': {
        demonstration.reqRec = event.data?.reqRec || 'off';
        demonstration.start(event.data.feedParameters);
        break;
      }
    }
  });
  if (checkHash()) processEmbedding.startEmbeddingFeed();
};
